// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'
import moment from 'moment';

export const DeleteInvoice = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        SpinnerMethods

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        error: false,
        totalInvoices: 0,
        totalLate: 0,
        totalRemaining: 0,
        invoice_events_counter: 1,
        events_queue: [],
        invoice_events: [],
        get_events_complete: false,
        invoice_events_deleted: false,
        delete_invoice_complete: false,
        set_rent_metrics_complete: false,
        update_rent_metrics_complete: false
        
    }),

    /*
    **  Watch em'
    */

    watch: {

        error: {

            immediate: true, // Load on created
            handler(error) {

                /*
                **  Handle the error
                **  @method: @here
                */

                if (error) this.handleErrorDelete();

            }

        },

        get_events_complete: {

            immediate: true, // Load on created
            handler(get_events_complete) {

                /*
                **  Step 2: Delete the invoice events
                **  @method: @here
                */

                if (!this.error && get_events_complete && this.invoice_events.length > 0) this.deleteEventsCollection();

            }

        },

        invoice_events_deleted: {

            immediate: true, // Load on created
            handler(invoice_events_deleted) {

                /*
                **  Step 3: Delete the invoice
                **  @method: @here
                */

                if (!this.error && invoice_events_deleted) this.deleteInvoiceDocument();

            }

        },

        delete_invoice_complete: {

            immediate: true, // Load on created
            handler(delete_invoice_complete) {

                /*
                **  Step 4: Set the rent metrics props
                **  @method: @here
                */

                if (!this.error && delete_invoice_complete) this.setRentMetricsDelete();

            }

        },

        set_rent_metrics_complete: {

            immediate: true, // Load on created
            handler(set_rent_metrics_complete) {

                /*
                **  Step 5: Update the rent metrics
                **  @method: @here
                */

                if (!this.error && set_rent_metrics_complete) this.updateRentMetricsDelete();

            }

        },

        update_rent_metrics_complete: {

            immediate: true, // Load on created
            handler(update_rent_metrics_complete) {

                /*
                **  Step 6: Finish the transaction
                **  @method: @here
                */

                if (!this.error && update_rent_metrics_complete) this.finishUpdateDelete();

            }

        }

    },

    /*
	**  Methods
    */
    
    methods: {

        deleteInvoiceHandler: function() {

            /* 
            ** Get the invoice events
            ** @method: @here
            */

            this.getInvoiceEvents();

        },

        handleErrorDelete: function() {

            /* 
            ** Hide the spinner
            ** @location: Mixins/Helpers/SpinnerMethods
            */

            this.hideSpinner();

            /* 
            ** Display error message
            ** @service: @Window/SweetAlert
            */

            this.$swal('Uh Oh!', 'We ran into a problem trying to delete the invoice.', 'error');

        },

        getInvoiceEvents: function() {

            try {

                /*
                **  Get the events for the invoice
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.invoice.relationships.lease).collection('rents').doc(this.invoice.relationships.rent).collection('invoices').doc(this.invoice.id).collection('events').get()
                .then(snapshot => {

                    if (snapshot.empty) return;

                    /*
                    **  Add to the prop
                    **  @prop: @here
                    */

                    snapshot.forEach(doc => {

                        this.invoice_events.push(doc.data());

                    });

                })
                .then(() => {

                    /*
                    **  Set the invoice get events prop
                    **  @prop: @here
                    */

                    this.get_events_complete = true;

                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Get the Invoices Events When Deleting an Invoice.',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'QYshqM16tBc9GEom8OOW',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Get the Invoice Events from Firestore When Deleting an Invoice.',
                    errorType: 'Firestore Database',
                    section: 'Events/Invoices',
                    uid: 'XQ8oLGjOAeIkO8RUOBVs',
                    error: e
                });

            }

        },

        deleteEventsCollection: function() {

            /*
            **  Delete the invoice
            **  @method: @here
            */

            try {

                if (this.invoice_events.length > 0) {

                    /*
                    **  Loop through em'
                    */

                    this.invoice_events.forEach(event => {

                        /*
                        **  Delete the event
                        **  @service: Firebase/Firestore
                        */

                        propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.invoice.relationships.lease).collection('rents').doc(this.invoice.relationships.rent).collection('invoices').doc(this.invoice.id).collection('events').doc(event.id).update({
                            'meta.deleted_at': moment().unix()
                        })
                        .then(() => {

                            /*
                            **  Increment the counter
                            */

                            if (this.invoice_events_counter < this.invoice_events.length) this.invoice_events_counter = this.invoice_events_counter + 1;
    
                        })
                        .then(() => {

                            /*
                            **  Check to see if we can move to the next step
                            **  @prop: @here
                            */

                            if (this.invoice_events_counter == this.invoice_events.length) this.invoice_events_deleted = true;
                            
                        })
                        .catch(error => {

                            /*
                            **  Set the error prop
                            **  @prop: @here
                            */
        
                            this.error = true;
        
                            /*
                            **  Send to Bugsnag
                            **  @service: Bugsnag/BugsnagService
                            */
        
                            this.reportAuthBugsnagError({
                                title: 'Delete Invoice Event in Firestore',
                                errorType: 'Application',
                                section: 'Events/Invoices',
                                uid: 'cLROsHhZ16GDZF92weck',
                                error: error
                            });
        
                        });
        
                    });

                }

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Delete Invoice Events While Deleting an Invoice in Firestore',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'wKK2JNrVyl2fpbuZ1mG5',
                    error: e
                });

            }

        },

        deleteInvoiceDocument: function() {

            /*
            **  Delete the invoice
            **  @method: @here
            */

            try {

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.invoice.relationships.lease).collection('rents').doc(this.invoice.relationships.rent).collection('invoices').doc(this.invoice.id).update({
                    'meta.deleted_at': moment().unix()
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.delete_invoice_complete = true;

                })
                .catch(error => {

                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */

                    this.error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Delete an invoice in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'In9CWLed71yk5VLb1zsC',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Deleting an invoice.',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'gAWR9qDbcCY2aVq2qb9c',
                    error: error
                });

            }

        },

        setRentMetricsDelete: function() {

            /*
            **  Set the rent metrics
            **  @props: @here
            */

            try {

                /*
                **  Set new base metrics
                */

                this.totalInvoices = this.rent.metrics.total_created_invoices - 1;
                this.totalLate = this.rent.metrics.total_late;

                /*
                **  Reset the total invoices
                */

                if (this.totalInvoices < 0) this.totalInvoices = 0;

                /*
                **  If late, adjust late totals
                */

                if (this.invoice.attributes.status == 'late') this.totalLate = this.rent.metrics.total_late - 1;

                /*
                **  Calculate total remaining
                */

                this.totalRemaining = this.rent.metrics.total_charges - this.totalInvoices;

                /*
                **  Complete the step
                */

                this.set_rent_metrics_complete = true;

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Update Totals Metrics When Deleting an Invoice in Firestore',
                    errorType: 'Application',
                    section: 'Events/Invoices',
                    uid: 'oMu0LIE1Q8RoG7UrQpkF',
                    error: e
                });

            }

        },

        updateRentMetricsDelete: function() {

            /*
            **  Update the doc
            **  @service: Firebase/Firestore
            */

            try {

                propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.rent.relationships.lease).collection('rents').doc(this.rent.id).update({
                
                    'metrics.total_late': this.totalLate,
                    'metrics.total_created_invoices': this.totalInvoices,
                    'metrics.total_remaining': this.totalRemaining,
                    'meta.updated_at': moment().unix()
    
                })
                .then(() => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.update_rent_metrics_complete = true;

                })
                .catch(error => {
    
                    /*
                    **  Set the error prop
                    **  @prop: @here
                    */
    
                    this.error = true;
    
                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
    
                    this.reportAuthBugsnagError({
                        title: 'Update Totals Metrics When Deleting an Invoice in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Invoices',
                        uid: 'MSFsVEwvRHVKXng2NEv6',
                        error: error
                    });
    
                });

            } catch (e) {

                /*
                **  Set the error prop
                **  @prop: @here
                */

                this.error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Query Firestore When Updating Totals Metrics All While Deleting an Invoice.',
                    errorType: 'Firestore Database',
                    section: 'Events/Invoices',
                    uid: 'xoDmuVVbENHNGj4bFIGO',
                    error: e
                });

            }

        },

        finishUpdateDelete: function() {

            /* 
            ** Close the menu
            ** @location: Components/Property/Lease/Invoices/ViewInvoiceMenu
            */

            this.closeViewInvoiceMenu();

            /* 
            ** Hide the spinner
            ** @location: Mixins/Helpers/SpinnerMethods
            */

            this.hideSpinner();

            /* 
            ** Display success message
            ** @service: @Window/SweetAlert
            */

            this.$swal('Success!', 'Your invoice has been deleted.', 'success');

        }

    }

}